import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useResults from "./useResults";
import SuccessImage from "../assets/success.png";
import PlainImage from "../assets/plainIco.png";
import StudentImage from "../assets/Student.png";
import AiRobotImage from "../assets/AiRobot.png";
import { useEffect, useRef, useState } from "react";
import { initGetResultsDetail, getResultsDetailSuccess } from "../redux/actions";
import { initSaveInterestedCareer, initSetResults } from "../redux/actions/scenariosActions";
const MODAL_TYPE = {
  BOOK_VALIDATION: 3,
  AI_REPORT: 2,
  OCCUPATION_PROFILE: 1,
  NAVIGATE_TO_CAREER_BUDDY: 4,
};
const modalInfo = {
  1: {
    title: 'Awesome!',
    image: PlainImage,
    text: `You'll be redirected to an external resource with all the details on this career outlook. Make sure to come back to Career Scoops to keep exploring and discovering more opportunities!`
  },
  2: {
    title: 'Ready!',
    image: SuccessImage,
    text: `Your AI Insights Report will open in a new tab! Be sure to dive into it to get your personalized insights and learn more about your career potential.`
  },
  3: {
    title: 'Let’s do this!',
    image: StudentImage,
    text: `Want to request a mentorship session with a professional in this career field? Click 'Okay' and we'll get the process started!`,
    text2: 'Note: Availability depends on your Career Scoops plan.'
  },
  4: {
    title: 'Let’s go!',
    image: AiRobotImage,
    text: `Launching your personalized AI Career Buddy! Chat live for instant career guidance and advice.`
  },
  5: {
    title: 'Success!',
    image: SuccessImage,
    text: `A representative from Career Scoops will take it from here.`
  },
}
const useCareer = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state.profileReducer);
  const [isConfirmModal, setIsConfirmModal] = useState(null)
  const [isSavedCareer, setIsSavedCareer] = useState(false)
  const { results_detail, isLoadingDetail, showLoader } = useSelector(
    (state) => state.scenariosReducer
  );
  const { aiAgents } = useSelector((state) => state.aiCompanionsReducer);
  const [careerBuddyId, setCareerBuddyId] = useState(null);

  useEffect(() => {
    if (aiAgents && aiAgents?.results && aiAgents?.results.length > 0) {
      aiAgents.results.forEach((item) => {
        if (item.name === "Career Buddy") {
          setCareerBuddyId(item.id);
        }
      });
    }
  }, [aiAgents]);

  const params = useParams();
  const hitOneTime = useRef(false)

  useEffect(() => {
    if (!hitOneTime.current) {
      dispatch(initGetResultsDetail(params.id))
      hitOneTime.current = true
    }
  }, [params.id])

  // useEffect(() => {
  //   setIsSavedCareer(false)
  // }, [results_detail?.interested])

  function handleBookValidation(id, val) {
    if (profile?.pricing_plan || profile?.affiliate_code) {
      handleBook(id, val);
    } else {
      navigate("/pricingplan");
    }
  }

  useEffect(() => {
    if (showLoader) {
      setIsSavedCareer(true)
      setTimeout(() => {
        setIsSavedCareer(false)
      }, 3000)
    }
  }, [showLoader])

  const handleUpdateResult = (booked) => {
    dispatch(
      getResultsDetailSuccess({
        ...results_detail,
        booked: booked,
      })
    );
  }
  const handlescore = (rate) => {
    dispatch(
      getResultsDetailSuccess({
        ...results_detail,
        score: rate,
      })
    );
  };
  const handleBook = (id, booked = true) => {
    if (profile.pricing_plan || profile.affiliate_code) {
      const recommendId = id || results_detail.id
      handleUpdateResult(booked)
      dispatch(
        initSetResults({
          id: recommendId,
          score: results_detail.score ? results_detail.score : 0,
          booked: booked,
        })
      );
    } else {
      navigate("/pricingplan");
    }
  };
  const handleBack = (id) => {
    results_detail.score &&
      dispatch(
        initSetResults({
          id: id || results_detail.id,
          score: results_detail.score,
          booked: false,
        })
      );
    navigate(-1);
  };
  const handleClose = (val = null) => [
    setIsConfirmModal(val)
  ]
  const handleConfirm = () => {
    if (isConfirmModal === MODAL_TYPE.BOOK_VALIDATION) {
      handleBookValidation(results_detail.id)
      setIsConfirmModal(5)
      return;
    } else if (isConfirmModal === MODAL_TYPE.AI_REPORT) {
      window.open(profile?.ai_report, '_blank');
    } else if (isConfirmModal === MODAL_TYPE.OCCUPATION_PROFILE) {
      window.open(`https://www.careeronestop.org/Toolkit/Careers/Occupations/occupation-profile.aspx?keyword=${results_detail?.unique_title?.title}&onetcode=${results_detail?.unique_title?.id}`, '_blank');
    } else if (isConfirmModal === MODAL_TYPE.NAVIGATE_TO_CAREER_BUDDY) {
      navigate(`/profile/ai-companions/${careerBuddyId}/career-buddy`)
    }
    setIsConfirmModal(null)
  }
  const navigateBack = () => {
    navigate(-1);
  };

  const handleSaveCareer = (val) => {
    const objectToDispatch = {
      interested: val,
      id: results_detail?.id
    }
    dispatch(initSaveInterestedCareer(objectToDispatch))
  }

  return {
    navigateBack,
    state: results_detail,
    profile,
    modalInfo,
    isConfirmModal,
    isSavedCareer,
    handleClose,
    handleConfirm,
    handlescore,
    handleBack,
    handleBook,
    handleBookValidation,
    handleSaveCareer,
    showLoader,
  };
};

export default useCareer;
